const meetings = [
	{
		path: '/meetings',
		name: 'meetings',
		component: () => import('@/views/meetings/list.vue'),
		meta: {
			layout: 'content',
		},
	},
]

export default meetings
